import React from 'react';
import { Link } from 'react-router-dom';
import { orderReadyForShipment } from '../../../../utils/stockQuantities';

/**
 * Блок "Дані для доставки" — спільний для десктопу та мобайлу.
 * variant: 'desktop' | 'mobile' — впливає лише на кнопку видалення накладної (іконка vs повна кнопка).
 */
const DeliveryDataCard = ({
  order,
  variant,
  onEditDelivery,
  copyToClipboard,
  detachOrderFromUser,
  disableButtons,
  onOpenCreateShipmentModal,
  onOpenDeleteShipmentModal,
  renderComments,
}) => {
  if (!order || !order.userInfo) return null;

  const userId = order.userId || order.userInfo?.userId;
  const isDesktop = variant === 'desktop';
  const terminalOrder = ['SENT', 'CANCELLED', 'RETURNED'].includes(order.orderStatus?.databaseValue);
  const shipmentBlocked = !orderReadyForShipment(order);

  return (
    <div className='card mb-3'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h5 className='card-title font-weight-bold m-0'>Дані для доставки: </h5>
        <i
          className='bi bi-pencil-fill cursor-pointer text-dark'
          data-toggle='modal'
          data-target='#editDeliveryModal'
          onClick={onEditDelivery}
        />
      </div>
      <div className='card-body'>
        {order.trackingNumber && (
          <>
            <div className={isDesktop ? 'd-flex align-items-center flex-wrap mb-3' : 'mb-3'}>
              <p className='card-text mb-0 mr-2' style={{ fontSize: '1.25rem' }}>
                <strong>Номер накладної:</strong>
                <span className=''>
                  {' '}{order.trackingNumber.slice(0, -4)}
                  <span className='font-weight-bold'>{order.trackingNumber.slice(-4)}</span>
                </span>
              </p>
              {isDesktop && (
                <i
                  className='bi bi-trash-fill cursor-pointer text-danger ml-1'
                  style={{ fontSize: '1.2rem' }}
                  data-toggle='modal'
                  data-target='#deleteShipmentModal'
                  onClick={onOpenDeleteShipmentModal}
                  title='Видалити накладну'
                />
              )}
            </div>
            {!isDesktop && (
              <div className='mb-3'>
                <button
                  type='button'
                  className='btn btn-sm btn-danger btn-block'
                  data-toggle='modal'
                  data-target='#deleteShipmentModal'
                  onClick={onOpenDeleteShipmentModal}
                >
                  Видалити накладну
                </button>
              </div>
            )}
          </>
        )}
        <p className='card-text mb-1'><strong>Тип доставки:</strong> {order.userInfo.receiveMethod.description}</p>
        <p className='card-text mb-1'><strong>Ім'я:</strong> {order.userInfo.name}</p>
        <p className='card-text mb-1'><strong>Прізвище:</strong> {order.userInfo.surname}</p>
        <p className='card-text mb-1' style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(order.userInfo.phone)}>
          <strong>Телефон:</strong> {order.userInfo.phone}
        </p>
        {order.userInfo.receiveMethod.id === 1 && (
          <div>
            <p className='card-text mb-1'><strong>Місто:</strong> {order.userInfo.city}</p>
            <p className='card-text mb-1'><strong>Номер відділення / поштомату:</strong> {order.userInfo.departmentNumber}</p>
          </div>
        )}
        {order.userInfo.receiveMethod.id === 2 && (
          <div>
            <p className='card-text mb-1'><strong>Місто:</strong> {order.userInfo.city}</p>
            <p className='card-text mb-1'><strong>Вулиця:</strong> {order.userInfo.street}</p>
            <p className='card-text mb-1'><strong>Номер будинку:</strong> {order.userInfo.buildingNumber}</p>
            <p className='card-text mb-1'><strong>Номер квартири:</strong> {order.userInfo.flatNumber}</p>
          </div>
        )}
        <p className='card-text mb-1'>
          <strong>ID користувача:</strong>{' '}
          {userId ? (
            <a
              href={`/admin/users/${userId}`}
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: '#007bff', fontWeight: 'bold', textDecoration: 'none' }}
              onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
              onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
            >
              {userId}
            </a>
          ) : (
            isDesktop ? 'Замовлення без авторизації' : 'Без авторизації'
          )}
          <span className='ml-2'>
            <i
              className={userId ? 'bi bi-pencil-fill cursor-pointer text-dark' : 'bi bi-person-plus-fill cursor-pointer text-primary'}
              style={{ fontSize: '1.2rem' }}
              data-toggle='modal'
              data-target='#attachUserModal'
              title={userId ? 'Змінити користувача' : 'Прикріпити користувача'}
            />
            {userId && (
              <i
                className='bi bi-person-x-fill cursor-pointer text-danger ml-2'
                style={{ fontSize: '1.2rem' }}
                onClick={detachOrderFromUser}
                disabled={disableButtons}
                title='Відкріпити користувача'
              />
            )}
          </span>
        </p>
        {!order.trackingNumber && order.userInfo.receiveMethod.id !== 3 && (
          <>
          {!terminalOrder && shipmentBlocked && <div className='alert alert-warning mt-3 mb-2' role='status'>
            <i className='bi bi-info-circle-fill mr-2' aria-hidden='true' />
            Створення накладної недоступне: усі товари мають бути зі статусом «На складі».
            {' '}<Link to='/admin/procurement'>Переглянути товари до замовлення</Link>
          </div>}
          <div className='d-flex justify-content-center'>
            <button
              className='btn btn-dark btn-block mt-2'
              data-toggle='modal'
              data-target='#selectWeightModal'
              onClick={onOpenCreateShipmentModal}
              disabled={disableButtons || terminalOrder || shipmentBlocked}
            >
              Створити накладну
            </button>
          </div>
          </>
        )}
        {variant === 'mobile' && renderComments && (
          <div className='pt-3'>
            {renderComments()}
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryDataCard;
